import { Chip, ChipStatus } from '@appcharge/shared-ui';
import { Offer } from 'common/contracts';
import { EAppearanceStatus, EScheduleType } from 'constants/enums';

import { appearanceUtils } from './scheduleUtils';

// Status mapping for schedule status (used in CheckoutLinksTable, PromotionsTable, RollingOffersTable)
export const scheduleStatusMapping: Record<string, ChipStatus> = {
  [EAppearanceStatus.RUNNING]: 'success',
  [EAppearanceStatus.UPCOMING]: 'warning',
  [EAppearanceStatus.ENDED]: 'secondary'
};

// Status mapping for active status (used across all offer tables)
export const activeStatusMapping: Record<string, ChipStatus> = {
  true: 'success',
  false: 'danger'
};

/**
 * Renders a schedule status chip based on the offer's schedule configuration
 */
export const renderScheduleStatusChip = (offer: Offer) => {
  const { status } = appearanceUtils.getStrongestStatusWithTime(
    offer?.schedule?.timeFrames
  );

  if (offer?.schedule?.permanent || !offer?.schedule) {
    return (
      <Chip variant="flat" status="active" className="capitalize">
        {EScheduleType.PERMANENT}
      </Chip>
    );
  } else {
    return (
      <Chip
        variant="flat"
        status={scheduleStatusMapping[status] || 'default'}
        className="capitalize"
      >
        {status}
      </Chip>
    );
  }
};
/**
 * Renders an active status chip based on the offer's active state
 */
export const renderActiveStatusChip = (isActive: boolean) => {
  return (
    <Chip
      variant="flat"
      status={activeStatusMapping[String(isActive)]}
      className="capitalize"
    >
      {isActive ? 'Active' : 'Inactive'}
    </Chip>
  );
};
